import React from 'react';
import { Badge } from '@mui/material';
import { usePaymentExceptions } from '../../../../views/PaymentMethodsExceptionsPage/hooks/usePaymentExceptions';

/** Owns its data, so the chain-wide payment queries only run while the Exceptions link is shown. */
const PaymentExceptionsBadge: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { paymentExceptions } = usePaymentExceptions();

  return (
    <Badge color="highlight" badgeContent={paymentExceptions?.length || 0}>
      {children}
    </Badge>
  );
};

export default PaymentExceptionsBadge;
